//NÃO SUBIR NO COMMIT ALTERAÇÃO DESSE ARQUIVO!!!!!!

const newApp = process.env.REACT_APP_NEW_PRODUCT === "true";

export default newApp;
